const TOGGLE = {
    toggle(nodeId) {
        let node = document.getElementById(nodeId);
        if (node == null) return;
        node.classList.toggle('is-hidden');
    }
}